export default {
  props: {
    swiperIndex: {
      default: 0,
    },
    total: {
      default: 0,
    },
    theme: {
    },
  },
  data(){
    return {
    }
  },
  methods:{
    handleSwiperPrev(){
      this.$emit('handleSwiperPrev');
    },
    handleSwiperNext(){
      this.$emit('handleSwiperNext');
    }
  }
};